import React from "react"

interface PlatformLabelProps {
  children: React.ReactNode
  variant?: "info" | "warning"
}

export default function PlatformLabel({
  children,
  variant = "info",
}: PlatformLabelProps) {
  return (
    <span className={`label label-${variant} platform-support-label`}>
      {children}
    </span>
  )
}
